import GTable from "./GTable";

export default GTable;
